<template>
    <div>
        {{ $t("txtAppStart") }}
    </div>
</template>

<script>
    export default {
      created: function () {
        if (this.$store.state.cards.length) {
          // das blockt aber history_prev
          this.$router.push({ name: 'card', params: { cardId: 0 } })
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/components/AppInit.vue